export default __webpack_public_path__ + "static/media/137.de3970a6.png";